import * as types from '../actions/action-types';
import type { BankDataAction } from '../actions/bank-data-actions';
import type { BankData } from '../api/auth-api';
import initialState from './initial-state';

export default function bankDataReducer(state: BankData[] = initialState.bankData, action: BankDataAction): BankData[] {
  switch (action.type) {
    case types.LOAD_BANK_DATA_SUCCESS:
      return action.bankData;
    default:
      return state;
  }
}
